import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

interface HeaderProps {
    title?: string;
    showBack?: boolean;
    showMenu?: boolean;
    showProfile?: boolean;
    onMenu?: () => void;
    onProfile?: () => void;
    onBack?: () => void;
}

const Header: React.FC<HeaderProps> = ({
    title = "Wellness Challenges",
    showBack = false,
    showMenu = true,
    showProfile = true,
    onMenu,
    onProfile,
    onBack
}) => {
    const navigate = useNavigate();
    const { theme } = useTheme();

    const handleBackPress = () => {
        if (onBack) {
            onBack();
        } else {
            navigate('/challenges');
        }
    };

    const handleMenuPress = () => {
        if (onMenu) {
            onMenu();
        }
    };

    const handleProfilePress = () => {
        if (onProfile) {
            onProfile();
        } else {
            navigate('/user-settings');
        }
    };

    return (
        <div className="sticky top-0 z-40" style={{ backgroundColor: theme.colors.background }}>
            <div className="flex items-center justify-between px-4 py-3 border-b" style={{ borderColor: theme.colors.border }}>
                {/* Left Icon */}
                <div className="flex items-center">
                    {showBack ? (
                        <button
                            onClick={handleBackPress}
                            className="p-2 rounded-lg hover:bg-opacity-10 transition-colors"
                            style={{ backgroundColor: `${theme.colors.primary}20` }}
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: theme.colors.text }}>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                    ) : showMenu ? (
                        <button
                            onClick={handleMenuPress}
                            className="p-2 rounded-lg hover:bg-opacity-10 transition-colors"
                            style={{ backgroundColor: `${theme.colors.primary}20` }}
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: theme.colors.text }}>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    ) : (
                        <div className="w-10 h-10" />
                    )}
                </div>

                {/* Center Title */}
                <div className="flex-1 text-center">
                    <h1 className="text-lg font-semibold" style={{ color: theme.colors.text }}>{title}</h1>
                </div>

                {/* Right Icon */}
                <div className="flex items-center">
                    {showProfile ? (
                        <button
                            onClick={handleProfilePress}
                            className="p-2 rounded-lg hover:bg-opacity-10 transition-colors"
                            style={{ backgroundColor: `${theme.colors.primary}20` }}
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: theme.colors.text }}>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </button>
                    ) : (
                        <div className="w-10 h-10" />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header; 